import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  Row, Col, Form, FormGroup } from 'reactstrap';
import { withRouter } from 'react-router';
import { customerDetailAction } from "../../actions";
import swal from 'sweetalert';
import { show, hide } from 'redux-modal';
import { Email } from './email';
import { handleEmailValidation } from './EmailValidation';

class UpdateEmail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                id: '',
                email: []
            },
            errors: {},
        }
        this.handleChildValue = this.handleChildValue.bind(this)
        this.handelUpdateEmail = this.handelUpdateEmail.bind(this)
        this.afterAction = this.afterAction.bind(this)
        this.toggle = this.toggle.bind(this)
        this.handelCansel = this.handelCansel.bind(this)
    }
    toggle() {
        const { onClose } = this.props
        onClose()
    }
    handleChildValue(data) {
        const { formData } = this.state
        const { name, value } = data;
        formData[name] = value;
        this.setState({ formData })
    }

    afterAction() {
        const { dispatch, getCustomerList } = this.props;
        dispatch(hide("bootstrap"))
        getCustomerList()
    }

    handelCansel() {
        const { dispatch } = this.props;
        dispatch(hide("bootstrap"))
    }

    handelUpdateEmail(e) {
        e.preventDefault();
        const { formData } = this.state;
        const { dispatch } = this.props;

        const result = handleEmailValidation(formData)
        this.setState({ errors: result.errors })
            if (result.formIsValid) {
                swal({
                    title: "Are you sure ?",
                    text: "Do you want to update email?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        formData.type = 'email'
                        dispatch(customerDetailAction.updateCustomerDetilEmail(formData, this));
                    }
                })
            }

        // else {
        //     dispatch(notify({ position: "tc", dismissible: false, message: '', status: "error" }))

        // }

    }
    componentDidMount() {
        const { customerDetail } = this.props;
        let { formData } = this.state;
        if (customerDetail) {
            formData.id = customerDetail.id
            formData.email = customerDetail.email ? customerDetail.email.split(',') : []
            this.setState({ formData })
        }

    }
    render() {
        const { errors, formData } = this.state
        return (

            <React.Fragment>
                <Form autocomplete="off">
                    <Row>
                        <Col md="12">
                            <FormGroup >
                                <Email handleChildValue={this.handleChildValue} errors={errors["email"]} emailData={formData.email} maxLength="150" />
                            </FormGroup>
                        </Col>
                    </Row><hr />
                    <button className="btn btn-secondary btn-sm pull-right" onClick={this.handelCansel} style={{'marginLeft':'10px'}} > Cancel </button>
                    <button onClick={this.handelUpdateEmail} className="btn btn-primary btn-sm pull-right"  > Update </button>
                </Form>
            </React.Fragment>

        )
    }
}

function mapStateToProps(state) {
    const { loading, data, customerDetail } = state.getCustomerStatusData
    return {
        loading,
        data,
        customerDetail
    }
}

const connectedUpdateEmail = withRouter(connect(mapStateToProps)(UpdateEmail))
export { connectedUpdateEmail as UpdateEmail }